// src/components/layout/MobileMenuToggle.tsx
import React from 'react';
import { Menu } from 'lucide-react';

interface MobileMenuToggleProps {
  onClick: () => void;
}

export const MobileMenuToggle: React.FC<MobileMenuToggleProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="mobile-menu-toggle"
      style={{
        position: 'fixed',
        top: '16px',
        left: '16px',
        zIndex: 998,
        width: '44px',
        height: '44px',
        borderRadius: '8px',
        backgroundColor: 'var(--color-surface)',
        border: '1px solid var(--color-border)',
        cursor: 'pointer',
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'var(--transition-fast)'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-primary)';
        e.currentTarget.style.borderColor = 'var(--color-primary)';
        const svg = e.currentTarget.querySelector('svg');
        if (svg) svg.style.color = 'white';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-surface)';
        e.currentTarget.style.borderColor = 'var(--color-border)';
        const svg = e.currentTarget.querySelector('svg');
        if (svg) svg.style.color = 'var(--color-primary)';
      }}
    >
      <Menu size={24} style={{ color: 'var(--color-primary)' }} />

      <style>{`
        @media (max-width: 768px) {
          .mobile-menu-toggle {
            display: flex !important;
          }
        }
      `}</style>
    </button>
  );
};
